import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { AlloyButton, Popup } from 'cat-ecommerce-alloy';
import { Drawer, DrawerBody, useDrawer } from '@cat-ecom/pcc-components';
import ContactDealerPopup from './ContactDealerPopup';
import CustomHeaderDrawer from '@app/components/common/CustomDrawer/CustomHeaderDrawer/CustomHeaderDrawer';
import styles from './ContactDealerPopupDrawer.module.scss';

const ContactDealerPopupDrawer = ({
  showContactDealerOnly,
  msg,
  catEntryId,
  popperOptions,
  isDrawer,
  availabilityMessageClassName,
  popupClassName
}) => {
  const {
    drawerProps: defaultDrawerProps,
    openDrawer,
    isDrawerOpen,
    closeDrawer
  } = useDrawer({
    hasBackdrop: true
  });

  const drawerProps = {
    ...defaultDrawerProps,
    onBlDrawerClose: e => {
      e.stopPropagation();
      closeDrawer();
    }
  };

  const { t } = useTranslation();
  const getDealerInitiator = (msg, onClick) => (
    <AlloyButton buttonType="link" className="p-0 text-start" onClick={onClick}>
      {msg || t('CONTACT_YOUR_DEALER')}
    </AlloyButton>
  );
  const showPopup = showContactDealerOnly || !msg;
  if (!showPopup) {
    return <div className={cx(availabilityMessageClassName)}>{msg}</div>;
  }
  if (isDrawer) {
    return (
      <>
        {getDealerInitiator(msg, () => openDrawer())}
        <Drawer
          {...drawerProps}
          isActive={isDrawerOpen}
          onBlDrawerClose={closeDrawer}
          orientation="bottom"
          verticalMaxHeight="default"
          hideCloseButton
          className={styles['contact-dealer__drawer']}
        >
          <CustomHeaderDrawer
            title={t('FOOTER_CONTACT_US')}
            onCloseDrawer={closeDrawer}
          />
          <DrawerBody>
            <div className="pt-4 pb-2">
              <ContactDealerPopup
                catEntryId={catEntryId}
                isShowContactUs={false}
                isDrawerVariant
              />
            </div>
          </DrawerBody>
        </Drawer>
      </>
    );
  }
  return (
    <>
      <div className="d-flex h-100">
        <Popup
          contents={<ContactDealerPopup catEntryId={catEntryId} />}
          initiator={getDealerInitiator(msg)}
          popperOptions={popperOptions}
          className={cx(popupClassName)}
        />
      </div>
      <div className={cx('d-none d-print-block', availabilityMessageClassName)}>
        {msg || t('CONTACT_YOUR_DEALER')}
      </div>
    </>
  );
};

ContactDealerPopupDrawer.propTypes = {
  showContactDealerOnly: PropTypes.bool,
  msg: PropTypes.string,
  catEntryId: PropTypes.string,
  popperOptions: PropTypes.shape(),
  isDrawer: PropTypes.bool,
  availabilityMessageClassName: PropTypes.string,
  popupClassName: PropTypes.string
};

export default ContactDealerPopupDrawer;
